var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55 15.515l8.639-8.638a.732.732 0 01.521-.228c.2-.003.377.073.532.228a.735.735 0 01.233.535c0 .2-.078.38-.233.534l-9.06 9.075a.868.868 0 01-.632.271.868.868 0 01-.633-.27l-4.175-4.176a.714.714 0 01-.22-.53.75.75 0 01.236-.539.735.735 0 01.534-.233c.202 0 .38.078.535.233l3.723 3.739z",
    fill: "currentColor"
  })));
}
SvgTick.displayName = 'Tick';
export default SvgTick;